import { ApiProperty } from "@nestjs/swagger";
import { FitEnum } from "@project-management-system/shared-models";

export class SIzeMatrixFabricBDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    imCode: string;

    @ApiProperty()
    style: string;

    @ApiProperty()
    // fit: FitEnum;
    fit: string;
    
    @ApiProperty()
    htColor: string;

    @ApiProperty()
    fabricCode: string;

    @ApiProperty()
    fabricContent:string;

    @ApiProperty()
    fabricCombinations:string;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
   isActive:boolean;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    updatedUser: string | null;


    @ApiProperty()
    updatedAt: string;
    @ApiProperty()
    createdAt: string;

}